import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import logo from '../../Images/logo-4.png';
import Room from "../../Images/Resized/Room/Suite_Room.webp";
import Lawn from "../../Images/Resized/lawn/Ashok Marg Lawn-01.png";
import Hall from "../../Images/Resized/Banquit Hall/WhatsApp Image 2025-06-11 at 2.35.10 PM.jpeg";
import { BASEAPIURL, token } from "../../env";
import { formatDate } from "../commonFunctionlity";

const Booking = ({ showBackButton = false }) => {
  const navigate = useNavigate();

  const [memberData, setMemberData] = useState({});
  const [memberImage, setMemberImage] = useState(logo);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const bookingOptions = useMemo(() => [
    {
      type: "Room",
      image: Room,
      title: "ROOM",
      description: "Private room space with attached bathroom and cozy interior.",
      price: "Book Now",
    },
    {
      type: "Lawn",
      image: Lawn,
      title: "LAWN",
      description: "Perfect for outdoor events and celebrations with open air ambiance.",
      price: "Book Now",
    },
    {
      type: "BanquetHall",
      image: Hall ,
      title: "PARTY HALL",
      description: "Spacious hall suitable for parties, weddings, and meetings.",
      price: "Book Now",
    },
  ], []);

  useEffect(() => {
    const memberID = sessionStorage.getItem('MemberID');
    if (!memberID) {
      setError("No MemberID found in sessionStorage.");
      setLoading(false);
      return;
    }

    const fetchMemberData = async () => {
      try {
        const response = await fetch(
          `${BASEAPIURL}/MemberByID?MainID=${memberID}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tokenData: token }),
          }
        );

        if (!response.ok) throw new Error(`Error: ${response.status}`);

        const result = await response.json();
        const data = result?.data || {};
        setMemberData(data);
        if (data?.ImageBase64?.startsWith("data:image")) {
          setMemberImage(data.ImageBase64);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch member data.");
      } finally {
        setLoading(false);
      }
    };

    fetchMemberData();
  }, []);

  const handleCardClick = (type) => navigate(`/Booking/${type}`);
  const handleBack = () => navigate(-1);

  if (loading) return <div className="text-center my-5">Loading...</div>;
  if (error) return <div className="text-center text-danger my-5">{error}</div>;

  return (
    <div className="container-fluid my-5">
      {showBackButton && (
        <>
          <div className="mb-4">
            <button
              className="btn btn-outline-secondary d-flex align-items-center"
              onClick={handleBack}
            >
              <IoArrowBackSharp className="me-2" />
              Back
            </button>
          </div>

          <div
            className="rounded-5"
            style={{
              minHeight: "50px",
              padding: "10px",
              marginTop: "50px",
              background: "linear-gradient(90deg, rgba(200,182,166,1) 17%, rgba(217,164,117,1) 66%, rgba(252,176,69,1) 100%)",
            }}
          >
            <div className="row align-items-center">
              <div className="col-12 col-md-4 text-center">
                <img
                  src={memberImage}
                  className="rounded-circle border border-4"
                  alt="member"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                    marginTop: "-70px",
                    backgroundColor: "white",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = logo;
                  }}
                />
              </div>
              <div className="col-12 col-md-4 text-center text-white mt-3">
                <h3>{memberData.MemName}</h3>
              </div>
              <div className="col-12 col-md-4 text-center text-white mt-3">
                <h5>Member since: {formatDate(memberData.MemRegDt)}</h5>
                <h5>Membership Type: {memberData.MemType}</h5>
                <h5 className="mt-2">Membership No: {memberData.MemMSNO}</h5>
              </div>
            </div>
          </div>
          <br /><br /><br />
        </>
      )}

      <div className="row justify-content-center gx-4 gy-4">
        {bookingOptions.map(({ type, image, title, description, price }, index) => (
          <div
            className="col-12 col-sm-6 col-md-4 d-flex justify-content-center"
            key={type}
          >

            <div
              role="button"
              tabIndex={0}
              onClick={() => handleCardClick(type)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleCardClick(type)}
              className="booking-card shadow text-center"
              style={{
                width: "100%",
                maxWidth: "300px",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
                backgroundColor: "#f4f0ea",
                transition: "all 0.3s ease",
                outline: "none",
              }}
              aria-label={`Book ${title}`}
            >
              <img
                src={image}
                alt={title}
                className="img-fluid"
                style={{ width: "100%", height: "180px", objectFit: "cover" }}
              />
              <div className="p-3">
                <h5 className="mb-2" style={{ fontWeight: "bold", color: "#5c4d3d" }}>{title}</h5>
                <p style={{ fontSize: "0.95rem", color: "#4a4a4a", minHeight: "60px" }}>{description}</p>
              </div>
              <div
                className="py-2"
                style={{
                  backgroundColor: "#c8b6a6",
                  color: "white",
                  fontWeight: "500",
                  fontSize: "1rem",
                  borderTop: "1px solid #b8a896",
                  borderBottomLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                }}
              >
                {price}
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .booking-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
        }
        .booking-card:focus {
          outline: 3px solid #007bff;
          outline-offset: 4px;
        }
      `}</style>
    </div>
  );
};

export default Booking;
